import type { Action } from 'react-sweet-state';
import { createActionsHook, createHook, createStore } from 'react-sweet-state';

type ConfluenceInviteContextKey = 'pageTitle' | 'type' | 'createdBy' | 'lastEditedTime';

type InviteEmailContextState = {
	inviteContext?: Partial<Record<ConfluenceInviteContextKey, string>>;
};

type InviteEmailContextActions = {
	setInviteContext: (
		context: Partial<Record<ConfluenceInviteContextKey, string>> | undefined,
	) => Action<InviteEmailContextState, void, void>;
	setInviteContextProp: (
		key: ConfluenceInviteContextKey,
		value: string,
	) => Action<InviteEmailContextState, void, void>;
};

const actions: InviteEmailContextActions = {
	setInviteContext:
		(context) =>
		({ setState }) => {
			setState({ inviteContext: context });
		},
	setInviteContextProp:
		(key: string, value: string) =>
		({ setState, getState }) => {
			setState({
				inviteContext: {
					...getState().inviteContext,
					[key]: value,
				},
			});
		},
};

// Define your state and actions
const store = createStore<InviteEmailContextState, InviteEmailContextActions>({
	initialState: {
		inviteContext: undefined,
	},
	actions,
	name: 'InviteEmailContextStore',
});

export const useImproveInviteEmailProductContextState = createHook(store);
export const useImproveInviteEmailProductContextActions = createActionsHook(store);
